import Application from '../../../application'
export default {
    mounted() {
        this.getAllRegions()
    },
    data: () => ({
        currentStep: 1,
        //Regions
        regionsHeaders: [
            {
                text: 'Región',
                align: 'left',
                value: 'REGION_NAME'
            },
            {
                text: 'Diplomas',
                align: 'left',
                value: 'DIPLOMAS'
            },
            {
                text: 'Seleccionar',
                align: 'left',
                sortable: false,
                value: 'REGION_NAME'
            },
            {
                text: 'Reporte',
                align: 'left',
                sortable: false,
                value: 'REGION_NAME'
            }
        ],
        searchRegions: '',
        regionsLoading: true,
        regions: [],
        selectedRegion: {},
        //Districts
        districtsHeaders: [
            {
                text: 'Districto',
                align: 'left',
                value: 'DISTRICT_NAME'
            },
            {
                text: 'Diplomas',
                align: 'left',
                value: 'DIPLOMAS'
            },
            {
                text: 'Seleccionar',
                align: 'left',
                sortable: false,
                value: 'DISTRICT_NAME'
            },
            {
                text: 'Reporte',
                align: 'left',
                sortable: false,
                value: 'DISTRICT_NAME'
            }
        ],
        searchdistricts: '',
        districtsLoading: true,
        districts: [],
        selectedDistrict: {},
        //Schools
        schoolsHeaders: [
            {
                text: 'Escuela',
                align: 'left',
                value: 'SCHOOL_NAME'
            },
            {
                text: 'Código de Escuela',
                align: 'left',
                value: 'SCHOOL_CODE'
            },
            {
                text: 'Municipio',
                align: 'left',
                value: 'MUNICIPALITY'
            },
            {
                text: 'Diplomas',
                align: 'left',
                value: 'DIPLOMAS'
            },
            {
                text: 'Seleccionar',
                align: 'left',
                sortable: false,
                value: 'SCHOOL_CODE'
            },
            {
                text: 'Reporte',
                align: 'left',
                sortable: false,
                value: 'SCHOOL_CODE'
            }
        ],
        searchSchools: '',
        schoolsLoading: true,
        schools: [],
        selectedSchool: {},
        //Students
        studentsHeaders: [
            {
                text: 'Número de Estudiante',
                align: 'left',
                value: 'STUDENT_ID'
            },
            {
                text: 'Apellidos',
                align: 'left',
                value: 'FULL_LAST_NAME'
            },
            {
                text: 'Nombre',
                align: 'left',
                value: 'FIRST_NAME'
            },
            {
                text: 'Inicial',
                align: 'left',
                value: 'MIDDLE_NAME'
            }
        ],
        searchStudents: '',
        studentsLoading: true,
        students: [],
        //selectedStudent: {},
    }),
    methods: {
        getAllRegions() {
            var self = this
            self.regionsLoading = true
            this.$ajax.get("/Diplomas/GetAllRegionsAsync").then(response => {
                self.regions = response.data
                self.regionsLoading = false
            }).catch(response => {
                self.regionsLoading = false
                self.$root.$snackbar('Ha ocurrido un error mientras se trataba de cargar los datos.', { color: 'error' })
            })
        },
        downloadReportDiplomasPorRegion(props) {
            window.open(Application.BaseUrl + '/ReportingServicesReports/GetDiplomasByRegionReport?rp_Region=' + props.item.REGION_NAME)
        },
        selectRegion(region) {
            this.selectedRegion = region.item
            this.currentStep = 2
            this.getAllDistrictsByRegion()
        },
        getAllDistrictsByRegion() {
            var self = this
            self.districtsLoading = true
            this.$ajax.get("/Diplomas/GetAllDistrictsByRegionAsync", { REGION_NAME: this.selectedRegion.REGION_NAME}).then(response => {
                self.districts = response.data
                self.districtsLoading = false
            }).catch(response => {
                self.districtsLoading = false
                self.$root.$snackbar('Ha ocurrido un error mientras se trataba de cargar los datos.', { color: 'error' })
            })
        },
        downloadReportDiplomasPorDistricto(props) {
            window.open(Application.BaseUrl + '/ReportingServicesReports/GetDiplomasByDistrictReport?rp_Region=' + this.selectedRegion.REGION_NAME +
                "&rp_District=" + props.item.DISTRICT_NAME)
        },
        selectDistrict(district) {
            this.selectedDistrict = district.item
            this.currentStep = 3
            this.getAllSchoolsByDistrict()
        },
        getAllSchoolsByDistrict() {
            var self = this
            self.schoolsLoading = true
            this.$ajax.get("/Diplomas/GetAllSchoolsByDistrictAsync", { DISTRICT_NAME: this.selectedDistrict.DISTRICT_NAME }).then(response => {
                self.schools = response.data
                self.schoolsLoading = false
            }).catch(response => {
                self.schoolsLoading = false
                self.$root.$snackbar('Ha ocurrido un error mientras se trataba de cargar los datos.', { color: 'error' })
            })
        },
        downloadReportDiplomasPorEscuela(props) {
            window.open(Application.BaseUrl + '/ReportingServicesReports/GetDiplomasBySchoolReport?rp_Region=' + this.selectedRegion.REGION_NAME +
                "&rp_District=" + this.selectedDistrict.DISTRICT_NAME +
                "&rp_School=" + props.item.SCHOOL_CODE)
        },
        selectSchool(school) {
            this.selectedSchool = school.item
            this.currentStep = 4
            this.getAllStudentsBySchool()
        },
        getAllStudentsBySchool() {
            var self = this
            self.studentsLoading = true
            this.$ajax.get("/Diplomas/GetAllStudentsBySchoolAsync", { SCHOOL_CODE: this.selectedSchool.SCHOOL_CODE }).then(response => {
                self.students = response.data
                self.studentsLoading = false
            }).catch(response => {
                self.studentsLoading = false
                self.$root.$snackbar('Ha ocurrido un error mientras se trataba de cargar los datos.', { color: 'error' })
            })
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/diplomas/index/script.js